import { useCallback, useEffect, useRef, useState } from 'react';

/**
 * On Linux/Chromium the `contextmenu` event fires on mousedown, so the menu can appear
 * underneath the pointer before the button is released and the release "clicks" the
 * first item. Ignore pointer events on the menu for a short moment after it opens.
 */
export const useContextMenuGuard = (ms = 220) => {
  const [guard, setGuard] = useState(false);
  const timer = useRef(null);
  const onOpenChange = useCallback((open) => {
    if (timer.current) clearTimeout(timer.current);
    if (open) {
      setGuard(true);
      timer.current = setTimeout(() => setGuard(false), ms);
    } else setGuard(false);
  }, [ms]);
  useEffect(() => () => timer.current && clearTimeout(timer.current), []);
  return { onOpenChange, contentStyle: guard ? { pointerEvents: 'none' } : undefined };
};
